// src/hooks/services/useGetServicesBySuppliers.js
import { useQuery } from "@tanstack/react-query";
import { getServicesBySuppliers } from "../../api/apiServices";
import i18next from "i18next";

/**
 * Hook to get services filtered by supplier IDs
 * @param {Array<number>} supplierIds - Array of supplier IDs
 * @param {boolean} enabled - Whether to enable the query
 */
const useGetServicesBySuppliers = (supplierIds = [], enabled = true) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["services-by-suppliers", supplierIds, i18next.language],
        queryFn: () => getServicesBySuppliers(supplierIds),
    });

    return {
        services: data?.data || [],
        error,
        isLoading,
        refetch,
    };
};

export default useGetServicesBySuppliers;
